export default __webpack_public_path__ + "static/media/PayCompleted.42639634.svg";